<template>
    <div class="mx-auto bg-gray-600 flex flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8">
        <NavLink v-for="r in routes" v-show="r.show" :href="r.route" :active="r.active">{{ r.name }}</NavLink>
    </div>
</template>

<script>
import NavLink from "@/Components/NavLink";

export default {
    components: {
        NavLink,
    },
    data() {
        return {
            routes: [
                {
                    name: 'История',
                    route: this.route('transactions.history'),
                    active: this.route().current('transactions.history'),
                    show: this.$page.props.auth.permissions.transactions.history,
                },
                {
                    name: 'История v3',
                    route: this.route('transactions.history.v3'),
                    active: this.route().current('transactions.history.v3'),
                    show: this.$page.props.auth.permissions.transactions.history,
                },
                {
                    name: 'Аналитика',
                    route: this.route('transactions.analytics'),
                    active: this.route().current('transactions.analytics'),
                    show: this.$page.props.auth.permissions.transactions.analytics,
                },
                {
                    name: 'Кроссчейн обмены',
                    route: this.route('transactions.crosschain', 'swaps'),
                    active: this.route().current('transactions.crosschain', 'swaps'),
                    show: this.$page.props.auth.permissions.transactions.crosschain,
                },
                {
                    name: 'Кроссчейн бриджи',
                    route: this.route('transactions.crosschain', 'transfers'),
                    active: this.route().current('transactions.crosschain', 'transfers'),
                    show: this.$page.props.auth.permissions.transactions.crosschain,
                },
            ],
        }
    },
}
</script>
